import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Instrument } from '@prlw/core/monitor/instrument.entity';
import {
  MainTableColumn,
  MainTableColumnId,
  ValueChanges,
} from '@prlw/core/monitor/types/main-table';
import { RowState } from '../table/main-table/table.component';
import { Subject } from 'rxjs';
import { SyncScrollService } from '@prlw/libs/sync-scroll/sync-scroll.service';

@Component({
  selector: 'prlw-table-row-ui',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SyncScrollService],
})
export class TableRowComponent {
  @Input() public instrument!: Instrument;
  @Input() public columns!: MainTableColumn<MainTableColumnId>[];
  @Input() public state!: RowState;
  @Input() public valueChanges: ValueChanges | null = null;
  @Input() public gridSize!: string;
  @Input() public tableContentClientWidthPx!: number;
  @Input() public tableHorizontalScrollPx!: number;
  @Input() public unpinned = true;
  @Input() public expandButtonVisible: boolean | null = null;

  @Output() public readonly toggleActive = new EventEmitter<void>();
  @Output() public readonly removeBasis = new EventEmitter<void>();

  private readonly scrollRefreshSubject$ = new Subject<void>();
  public readonly scrollRefresh$ = this.scrollRefreshSubject$.asObservable();

  @HostListener('click')
  public onClick(): void {
    // Table row changes its dimensions shortly after expanding/folding,
    // so we need to update the scroll
    this.scrollRefreshSubject$.next();
  }

  @HostBinding('class.active')
  public get active(): boolean {
    return this.state === RowState.ACTIVE;
  }

  public get hovered(): boolean {
    return this.state === RowState.HOVERED;
  }

  @HostBinding('style')
  public get style(): object {
    return this.active
      ? {
          width: `${this.tableContentClientWidthPx}px`,
          left: `${this.tableHorizontalScrollPx}px`,
        }
      : {};
  }

  isOnTop(columnId: number) {
    return columnId === MainTableColumnId.BASIS;
  }
}
